module.exports = __webpack_public_path__ + "static/img/no-data.4c5bdcea.png";